import {get} from 'lodash';

export default (state = {}, {coach, competency}: any) => {
  return {
    ...state,
    allProfiles: {
      ...get(state, 'allProfiles', {}),
      [coach.id]: coach,
    },
    coachCompetencies: {
      ...get(state, 'coachCompetencies', {}),
      [coach.id]: competency,
    },
  };
};
